module.exports = __webpack_public_path__ + "@/assets/img/no-documents.3d147d30.svg";